import {
    Grid,
    Typography,
    Tab,
    Tabs,
    Box,
    Paper,
    Card,
    MenuItem,
    FormControl,
    Select,
    Chip,
    Button,
    OutlinedInput,
    Avatar,
    TextField,
    Checkbox,
    Tooltip,
    Link
} from "@mui/material";
import { styled } from "@mui/system";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Container } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import globals from "../globals";
import EditNoteIcon from '@mui/icons-material/EditNote';
import ChatIcon from '@mui/icons-material/Chat';
import RTE from "../components/course_edit/rich_text_editor";
import BlueButton from "../components/blueButton";
import AddIcon from '@mui/icons-material/Add';
import { Add, DataArray, PartyMode } from "@mui/icons-material";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import RedButton from "../components/redButton";
import LoadingIcon from "../components/loading";
import Countdown from "../components/countdown"
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import SummerSchoolRegistrations from "./summer_school_registrations";
import ExamGrading from "./exam_grading";

// Only the summer school leader sees the dedicated registrations tab.
const SUMMER_SCHOOL_INSTRUCTOR_ID = 404;


const DashboardTextField = styled(TextField)(() => ({
    borderRadius: 3,
    // backgroundColor: globals.colors.lightPink, // default background
    // '&:hover': {
    //     backgroundColor: globals.colors.lightPink, // no color on hover
    // },
    '& .MuiOutlinedInput-root': {
        '& .MuiInputBase-input': {
            backgroundColor: globals.colors.lightPink,
        },
        '& fieldset': {
            borderColor: 'transparent', // no border by default
        },
        '&:hover fieldset': {
            borderColor: 'transparent', // no border on hover
        },
        '&.Mui-focused fieldset': {
            borderColor: globals.colors.lightRed, // red border when typing
        },
    },
}));


const hours = [
    "9:00 - 10:00",
    "10:00 - 11:00",
    "11:00 - 12:00",
    "12:00 - 13:00",
    "13:00 - 14:00",
    "14:00 - 15:00",
    "15:00 - 16:00",
    "16:00 - 17:00",
    "17:00 - 18:00",
    "18:00 - 19:00",
    "19:00 - 20:00",
    "20:00 - 21:00",
];

const days = [
    "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота", "Неделя"
]



// const payment_history = [
//     {
//         id: 1,
//         date: "22.02.2024",
//         course_name: 'Уроци по математика 7-ми клас',
//         student: 'Ivan Ivanov',
//         num: 3
//     },
//     {
//         id: 2,
//         date: "26.10.2024",
//         course_name: 'Уроци по математика 9-ти клас',
//         student: 'Patric Star',
//         num: 3
//     },
//     {
//         id: 3,
//         date: "06.10.2025",
//         course_name: 'Уроци по математика 7-ми клас',
//         student: 'Jessica Alba',
//         num: 3
//     },

// ]

const CALENDAR_HEIGHT = 48;
const CALENDAR_PADDIONG_TOP = 8;

const CalendarProps = {
    PaperProps: {
        style: {
            maxHeight: CALENDAR_HEIGHT * 4.5 + CALENDAR_PADDIONG_TOP,
            width: 250,
        },
    },
};

// Dialog for delete a course
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// For Calendar with hours
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


const TeacherDashboard = ({ isInstructor }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();
    const { user, token } = useAuth();
    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') ? parseInt(searchParams.get('tab')) : 0);
    const [calendar, setCalendar] = React.useState({
        'Понеделник': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].monday : [],
        'Вторник': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].tuesday : [],
        'Сряда': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].wednesday : [],
        'Четвъртък': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].thursday : [],
        'Петък': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].friday : [],
        'Събота': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].saturday : [],
        'Неделя': (user.time_slots.length > 0) ? user.time_slots[user.time_slots.length - 1].sunday : [],
    });
    const [openDialog, setOpenDialog] = React.useState(false);
    const [personName, setPersonName] = React.useState(0);
    const [studentId, setStudentId] = React.useState(0);
    const [avatar, setAvatar] = React.useState((user) ? user.image_url : 0);
    const [avatarFile, setAvatarFile] = React.useState(null);
    const [chats, setChats] = React.useState([]);
    const [meetings, setMeetings] = React.useState([]);
    const [dashboardLoading, setDashboardLoading] = React.useState(true);
    const [payments, setPayments] = React.useState([]);
    const [nextMeeting, setNextMeeting] = React.useState(null);
    const [createMeetingAnyways, setCreateMeetingAnyways] = React.useState(false);
    const [hasEnoughReservedLessons, setHasEnoughReservedLessons] = React.useState({});
    const [timeslotsSubmissionLoading, setTimeslotsSubmissionLoading] = React.useState(false);
    const [notifications, setNotifications] = React.useState([]);
    const [instructorExams, setInstructorExams] = React.useState([]);

    // Changing password
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [myCourses, setMyCourses] = React.useState([]);

    const [userData, setUserData] = React.useState({
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone_number: user.phone_number,
        password: "",
        description: user.description,
        education: user.education,
    });

    const handleUserDataChange = (event) => {
        setUserData({
            ...userData,
            [event.target.id]: event.target.value
        });
    }

    useEffect(() => {
        fetch(globals.apiUrl + '/courses/my-dashboard', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                console.log(data)
                setMyCourses(data.courses);
                setChats(data.chats);
                setMeetings(data.meetings);
                setPayments(data.payments);
                setNextMeeting(data.next_meeting);
                setNotifications(data.notifications);
                setDashboardLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
            })

    }, []);

    // Fetch the instructor's own exams so the grading tab appears only when relevant.
    useEffect(() => {
        fetch(globals.apiUrl + '/exams/instructor/mine', {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(response => response.json())
            .then(data => setInstructorExams(Array.isArray(data) ? data : []))
            .catch(error => console.error('Error:', error));
    }, []);

    const hasExams = instructorExams.length > 0;
    // The exams tab sits after the (conditional) summer-school tab.
    const examTabIndex = (user.id === SUMMER_SCHOOL_INSTRUCTOR_ID) ? 9 : 8;

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setSearchParams({ tab: newValue });
    };

    // Handler that updates state for a specific day
    const handleCalendarChange = (day) => (event) => {
        const { value } = event.target;
        //console.log("calendar", calendar);
        setCalendar((prev) => ({
            ...prev,
            [day]: typeof value === "string" ? value.split(",") : value,
        }));
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleChangeStudent = (courseKey) => (event) => {
        const value = event.target.value;
        //console.log(studentId);
        setPersonName((prev) => ({
            ...prev,
            [courseKey]: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatar(URL.createObjectURL(file));
            setAvatarFile(file);
        }
    };

    const handleDeleteCourse = (courseId) => {
        fetch(globals.apiUrl + '/courses/' + courseId, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setMyCourses(myCourses.filter(course => course.id !== courseId));
            })
            .catch(error => {
                console.error('Error:', error);
            })
    }

    const handleSaveChanges = (e) => {
        e.preventDefault();
        //console.log(userData);
        //console.log(token);

        const data = {
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            phone_number: userData.phone_number,
            description: userData.description,
            education: userData.education,
        }
        if (userData.password.length > 0 && userData.password === confirmPassword) {
            data.password = userData.password;
        }
        //console.log(data);

        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        if (avatarFile) {
            formData.append("file", avatarFile);
        }
        // formData.append("image_url", null);

        fetch(globals.apiUrl + "/auth/me", {
            method: "PUT",
            body: formData,
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(response => {
                if (response.detail) {
                    // setError(response.detail);
                    //console.log(response.detail);
                }
                else {
                    navigate(0);
                }

            })
            .then(data => {
                //console.log(data);
                navigate(0);
            })
            .catch(error => {
                console.error('Error:', error);
            })
    }

    const areAllArraysEmpty = (array) => {
        return Object.values(array).every(subArray => subArray.length === 0);
    }

    const handleSaveCalendar = () => {
        //console.log("calendar", calendar);
        const data = {
            monday: calendar['Понеделник'] || [],
            tuesday: calendar['Вторник'] || [],
            wednesday: calendar['Сряда'] || [],
            thursday: calendar['Четвъртък'] || [],
            friday: calendar['Петък'] || [],
            saturday: calendar['Събота'] || [],
            sunday: calendar['Неделя'] || [],
        }
        if (areAllArraysEmpty(data)) {
            //console.log("data is empty");
            return;
        }

        setTimeslotsSubmissionLoading(true);
        //console.log("data", JSON.stringify(data));
        fetch(globals.apiUrl + '/courses/timeslots/instructor', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setTimeslotsSubmissionLoading(false);
                navigate(0);
            })
            .catch(error => {
                console.error('Error:', error);
            })
    }
    //console.log(createMeetingAnyways);


    const handleGoToEdit = (courseId) => (event) => {
        event.preventDefault();
        navigate(`/materials/${courseId}/${studentId}`);
    }

    return (
        <Container>
            {(nextMeeting && JSON.stringify(nextMeeting) != '{}') &&
                <a href='/upcoming-meetings' style={{ textDecoration: 'none' }}>
                    <Grid container direction={'column'} >
                        <Paper sx={{ backgroundColor: globals.colors.lightBlue, p: 1 }}>
                            <Grid item>
                                <Typography sx={{ fontSize: 18, fontWeight: 'bold', color: globals.colors.backgroundColor }}>
                                    <AccessAlarmIcon sx={{ mb: -0.7, mr: 1 }} />Следващият Ви урок започва след: <Countdown targetDate={nextMeeting.from_time} /></Typography>
                            </Grid>
                        </Paper>
                    </Grid>
                </a>}
            <Typography sx={{ mb: 2, color: globals.colors.darkBlue, fontSize: 25, fontWeight: 'bold', mt: 3 }}>Моят профил</Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={8}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        sx={{
                            border: 1, borderColor: "divider", border: 1,
                            borderColor: "divider",
                            "& .MuiTab-root": {
                                color: globals.colors.textColor,             // Unselected text color
                            },
                            "& .Mui-selected": {
                                color: globals.colors.lightRed, // Selected tab text color
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: globals.colors.lightRed, // Underline color
                            },
                        }}
                        textColor={globals.colors.lightRed}
                    >
                        <Tab label="Курсове" sx={{ textTransform: "capitalize" }} />
                        <Tab label="График" sx={{ textTransform: "capitalize" }} />
                        <Tab label="Срещи" sx={{ textTransform: "capitalize" }} />
                        <Tab label="Материали" sx={{ textTransform: "capitalize" }} />
                        <Tab label="Разговори" sx={{ textTransform: "capitalize" }} />
                        <Tab label="История на закупените уроци" sx={{ textTransform: "none" }} />
                        <Tab label="За мен" sx={{ textTransform: "capitalize" }} />
                        <Tab label="Правила" sx={{ textTransform: "capitalize" }} />
                        {user.id === SUMMER_SCHOOL_INSTRUCTOR_ID && (
                            <Tab label="Лятна занималня" sx={{ textTransform: "capitalize" }} />
                        )}
                        {hasExams && (
                            <Tab label="Изпити" sx={{ textTransform: "capitalize" }} />
                        )}
                    </Tabs>

                    {/* Courses */}
                    <TabPanel value={tabValue} index={0}>
                        <Grid container>
                            <BlueButton text='Добави курс' pX={5} href='/edit-course' />
                        </Grid>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={3}>
                                {myCourses.map((course, index) => (
                                    <Grid item xs={12} sm={12} key={index}>
                                        <Paper elevation={5} sx={{
                                            backgroundColor: globals.colors.lightPink
                                        }}>
                                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                                <Grid item xs={12} sm={5}>
                                                    <img src={course.image_url} style={{ height: 140, width: 250 }} />
                                                </Grid>
                                                <Grid item xs={12} sm={7}>
                                                    <Link href={`/course/${course.id}`} sx={{ textDecoration: 'none', color: globals.colors.darkBlue }}>
                                                        <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
                                                            {(course.title.length <= 38) ? course.title : course.title.slice(0, 35).concat('...')}
                                                        </Typography>
                                                    </Link>
                                                    <Typography>{course.instructor_name}</Typography>
                                                    <Grid container sx={{ mt: 3 }}>
                                                        <Grid item>
                                                            <Typography sx={{ fontWeight: 'bold' }}>Статус</Typography>
                                                            {!course.is_published ?
                                                                <Typography sx={{
                                                                    fontSize: 17, color: globals.colors.darkRed
                                                                }}>Чернова</Typography> : <Typography sx={{ fontSize: 17, color: globals.colors.darkGreen }}>Активен</Typography>
                                                            }
                                                        </Grid>
                                                        <Grid item>
                                                            <IconButton onClick={() => { navigate('/edit-course', { state: { course: course } }); }} sx={{ ml: 2, color: globals.colors.textColor, fontSize: 40 }}><EditNoteIcon fontSize="inherit" /></IconButton>
                                                            <IconButton sx={{ color: globals.colors.gray, fontSize: 20 }} onClick={handleClickOpenDialog}><CancelIcon fontSize="inherit" /></IconButton>
                                                            <Dialog
                                                                open={openDialog}
                                                                slots={{
                                                                    transition: Transition,
                                                                }}
                                                                keepMounted
                                                                onClose={handleClose}
                                                                aria-describedby="alert-dialog-slide-description"
                                                            >
                                                                <DialogTitle sx={{ color: globals.colors.darkRed }}>{"Сигурни ли сте, че искате да изтриете този курс?"}</DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText id="alert-dialog-slide-description">
                                                                        Няма да имате възможност да го върнете отново! Изтриването на курс е вечно.
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button onClick={() => { handleDeleteCourse(course.id); handleClose(); }} sx={{ mt: 3, color: globals.colors.darkRed, textTransform: 'none', fontWeight: 'bold' }}>Да, сигурен съм</Button>
                                                                    <Button onClick={handleClose} sx={{ mt: 3, color: globals.colors.darkBlue, textTransform: 'none', fontWeight: 'bold' }}>Не, върни ме обратно</Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        }
                    </TabPanel>

                    {/* Calendar */}
                    <TabPanel value={tabValue} index={1}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <>
                                <Grid container>
                                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 20, mb: 3 }}>Изберете дните и часовете, в които можете да преподавате</Typography>
                                </Grid>
                                {/* Days */}
                                {days.map((day) => (
                                    <Grid key={day} sx={{ mb: 3 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>{day}</Typography>
                                        <Grid container sx={{ mt: 1 }}>
                                            <FormControl sx={{ width: 400 }}>
                                                <Select
                                                    multiple
                                                    value={calendar[day] || []}
                                                    onChange={handleCalendarChange(day)}
                                                    renderValue={(selected) => (
                                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                            {selected.map((value) => (
                                                                <Chip key={value} label={value} />
                                                            ))}
                                                        </Box>
                                                    )}
                                                    MenuProps={CalendarProps}
                                                    sx={{
                                                        backgroundColor: globals.colors.backgroundColor,
                                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: globals.colors.darkRed,
                                                        },
                                                    }}
                                                >
                                                    {hours.map((hour) => (
                                                        <MenuItem key={hour} value={hour}>
                                                            {hour}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid container spacing={5}>
                                    <Grid item>
                                        <Button variant='contained' href='#' type='submit' size='large' sx={{
                                            mt: 3, px: 5, backgroundColor: globals.colors.lightRed, '&:hover': {
                                                backgroundColor: globals.colors.darkRed,
                                            },
                                        }}
                                            onClick={handleSaveCalendar} s
                                        > Запази</Button>
                                    </Grid>
                                    <Grid item >
                                        <IconButton sx={{ mt: 3, color: globals.colors.textColor }} onClick={() => setCalendar({})}><CancelIcon /></IconButton>
                                    </Grid>
                                    <Grid item>
                                        {timeslotsSubmissionLoading ? <LoadingIcon sx={{ mt: 3 }} /> : null}
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </TabPanel>

                    {/* Zoom meetings */}
                    <TabPanel value={tabValue} index={2}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, mb: 1, fontWeight: 'bold' }}>Изберете в кой курс и за кой ученик да направите следващата си среща:</Typography>
                        <RedButton text={'Предстоящи срещи'} href='/upcoming-meetings' />
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={5}>
                                {meetings.map((course, index) => (
                                    <Grid item xs={12} sm={12} key={index}>
                                        <Paper elevation={5} sx={{
                                            backgroundColor: globals.colors.lightPink
                                        }}>
                                            <Grid container spacing={2} sx={{ mt: 4 }}>
                                                <Grid item xs={12} sm={5}>
                                                    <img src={course.image_url} style={{ height: 140, width: 250 }} />
                                                </Grid>
                                                <Grid item xs={12} sm={7}>
                                                    <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
                                                        {course.title}
                                                    </Typography>
                                                    <Typography>{course.instructor_name}</Typography>
                                                    <Grid container>
                                                        <Grid item>
                                                            <FormControl sx={{ m: 1, width: 200, mt: 3 }}>
                                                                <Select
                                                                    displayEmpty
                                                                    input={<OutlinedInput />}
                                                                    value={personName[course.id] || ""}
                                                                    onChange={handleChangeStudent(course.id)}
                                                                    renderValue={(selected) => {
                                                                        if (!selected || selected.length === 0) return <em>Ученик</em>;
                                                                        return selected;
                                                                    }}
                                                                    MenuProps={CalendarProps}
                                                                    sx={{
                                                                        backgroundColor: globals.colors.lightRed,
                                                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                            borderColor: globals.colors.lightRed,
                                                                        }, color: globals.colors.backgroundColor
                                                                    }}
                                                                >
                                                                    <MenuItem disabled value="">
                                                                        <em>Ученик</em>
                                                                    </MenuItem>
                                                                    {course.students?.map(({ id: student_id, name }) => (
                                                                        <MenuItem
                                                                            key={name}
                                                                            value={name}
                                                                            style={{ color: globals.colors.darkBlue }}
                                                                            onClick={() => { setStudentId(student_id); setHasEnoughReservedLessons({ ...hasEnoughReservedLessons, [course.id]: course.students.find(student => student.id == student_id).has_enough_reserved_lessons }) }}
                                                                        >
                                                                            {name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item>
                                                            <Button disabled={((personName[course.id] ? false : true) || ((hasEnoughReservedLessons[course.id] != null) ? !hasEnoughReservedLessons[course.id] : false)) && !createMeetingAnyways} variant='contained' href={`/meeting/${course.id}/${studentId}`} type='submit' size='large' sx={{
                                                                mt: 4, px: 5, backgroundColor: globals.colors.darkBlue, textTransform: 'none', '&:hover': {
                                                                    backgroundColor: globals.colors.lightBlue
                                                                },
                                                            }}>Към Zoom</Button>
                                                        </Grid>
                                                    </Grid>
                                                    {((hasEnoughReservedLessons[course.id] != null) ? !hasEnoughReservedLessons[course.id] : false) &&
                                                        <Typography sx={{ fontSize: 11 }}>
                                                            <Tooltip title='Изберете тази опция само ако се доверявате на ученика. Платформата не гарантира получаването на заплащане.'>
                                                                <Checkbox sx={{
                                                                    "& .MuiSvgIcon-root": {
                                                                        fill: globals.colors.darkBlue,
                                                                    },
                                                                }} checked={createMeetingAnyways} onChange={() => setCreateMeetingAnyways(!createMeetingAnyways)} />
                                                            </Tooltip>
                                                            Съгласявам се да проведа урока преди ученикът да е заплатил.
                                                        </Typography>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        }
                    </TabPanel>


                    {/* Materials */}
                    <TabPanel value={tabValue} index={3}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, mb: 3, fontWeight: 'bold' }}>Моля, изберете в кой курс и за кой ученик искате да  добавите материали:</Typography>
                                <Grid container spacing={5}>
                                    {myCourses.map((course, index) => (
                                        <Grid item xs={12} sm={12} key={index}>
                                            <Paper elevation={5} sx={{
                                                backgroundColor: globals.colors.lightPink
                                            }}>
                                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                                    <Grid item xs={12} sm={5}>
                                                        <img src={course.image_url} style={{ height: 140, width: 250 }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={7}>
                                                        <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
                                                            {course.title}
                                                        </Typography>
                                                        <Typography>{course.instructor_name}</Typography>
                                                        <Grid container>
                                                            <Grid item>
                                                                <FormControl sx={{ m: 1, width: 200, mt: 3 }}>
                                                                    <Select
                                                                        displayEmpty
                                                                        input={<OutlinedInput />}
                                                                        value={personName[course.id] || ""}
                                                                        onChange={handleChangeStudent(course.id)}
                                                                        renderValue={(selected) => {
                                                                            if (!selected || selected.length === 0) return <em>Ученик</em>;
                                                                            return selected;
                                                                        }}
                                                                        MenuProps={CalendarProps}
                                                                        sx={{
                                                                            backgroundColor: globals.colors.lightRed,
                                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                                borderColor: globals.colors.lightRed,
                                                                            }, color: globals.colors.backgroundColor
                                                                        }}
                                                                    >
                                                                        <MenuItem disabled value="">
                                                                            <em>Ученик</em>
                                                                        </MenuItem>
                                                                        {course.students?.map(({ id: student_id, first_name, last_name }) => (
                                                                            <MenuItem
                                                                                key={first_name + " " + last_name}
                                                                                value={first_name + " " + last_name}
                                                                                style={{ color: globals.colors.darkBlue }}
                                                                                onClick={() => setStudentId(student_id)}
                                                                            >
                                                                                {first_name} {last_name}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item>
                                                                <Button disabled={personName[course.id] ? false : true} onClick={handleGoToEdit(course.id)} variant='contained' type='submit' size='large' sx={{
                                                                    mt: 4, px: 5, backgroundColor: globals.colors.darkBlue, textTransform: 'none', '&:hover': {
                                                                        backgroundColor: globals.colors.lightBlue
                                                                    },
                                                                }}>Към Редактор</Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        }
                    </TabPanel>

                    {/* Chat */}
                    <TabPanel value={tabValue} index={4}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container direction={'column'}>
                                {chats.map((chat, index) => (
                                    <Paper sx={{ my: 1 }} elevation={4}>
                                        <Grid item sx={{ my: 2, ml: 2 }}>
                                            <Grid container sx={{ display: 'flex' }}>
                                                <Grid item>
                                                    <Typography sx={{ mx: 3, mt: 1 }}>{chat.student.first_name} {chat.student.last_name}</Typography>
                                                    <Typography sx={{ mx: 3, fontSize: 13 }}>{chat.course_title}</Typography>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton sx={{ mt: 1, color: globals.colors.darkBlue }} href={`/chat/${chat.id}`}><ChatIcon /></IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                ))}
                            </Grid>
                        }
                    </TabPanel>

                    {/* Payment history */}
                    <TabPanel value={tabValue} index={5}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container>
                                <Paper elevation={3} sx={{ backgroundColor: globals.colors.lightPink }}>
                                    <Grid>
                                        {payments.map((history) => (
                                            <Grid key={history.id} sx={{ padding: 2, borderBottom: '1px solid #ffff' }}>
                                                <Grid container alignItems="center" sx={{ mb: 1, mr: 2 }} justifyContent="center" spacing={3}>
                                                    <Grid item sm={3} xs={6} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Дата</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{history.created_at.split('T')[0]}</Typography>
                                                    </Grid>
                                                    <Grid item sm={3} xs={6} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Курс</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{history.course_title}</Typography>
                                                    </Grid>
                                                    <Grid item sm={3} xs={6} textAlign={'center'}>
                                                        <Typography noWrap sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Ученик</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{history.student_name}</Typography>
                                                    </Grid>
                                                    <Grid item sm={3} xs={6} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Брой закупени уроци</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{history.amount}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Paper>
                            </Grid>
                        }
                    </TabPanel>

                    {/* My dashboard */}
                    <TabPanel value={tabValue} index={6}>
                        <Grid container direction={'column'}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, mb: 3, fontWeight: 'bold' }}>Профилна снимка</Typography>
                            <Grid item>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar
                                            src={avatar}
                                            sx={{ width: 90, height: 90 }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Typography sx={{ color: globals.colors.gray, fontSize: 12, mx: 2, mt: 2 }}>JPG или PNG</Typography>
                                        <Button variant='contained' component='label' size={'small'} sx={{
                                            backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                                backgroundColor: globals.colors.darkRed
                                            },
                                        }}>
                                            Смени снимката
                                            <input
                                                type="file"
                                                accept="image/*"
                                                hidden
                                                onChange={handleImageChange}
                                            />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container sx={{ mt: 0 }} spacing={5}>
                                <Grid item sm={6}>
                                    <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Username</Typography>
                                    <DashboardTextField disabled label={`@${user.username}`} fullWidth />
                                </Grid>
                                <Grid item sm={6}>
                                    <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>E-Mail</Typography>
                                    <DashboardTextField defaultValue={user.email} fullWidth id="email" onChange={handleUserDataChange} />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Име</Typography>
                                <DashboardTextField fullWidth value={userData.first_name} id="first_name" onChange={handleUserDataChange} />
                            </Grid>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Фамилия</Typography>
                                <DashboardTextField fullWidth value={userData.last_name} id="last_name" onChange={handleUserDataChange} />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Смени парола</Typography>
                                <DashboardTextField fullWidth
                                    type="password"
                                    id="password"
                                    value={userData.password}
                                    onChange={(e) => { setPassword(e.target.value); handleUserDataChange(e); }} />
                            </Grid>
                            <Grid item sm={6}>
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', }}>Повтори паролата</Typography>
                                <DashboardTextField fullWidth
                                    sx={{ mt: 1 }}
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    error={confirmPassword.length > 0 && confirmPassword !== password}
                                    helperText={
                                        confirmPassword.length > 0 && confirmPassword !== password
                                            ? "Паролите не съвпадат"
                                            : ""
                                    } />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Телефонен номер</Typography>
                                <DashboardTextField fullWidth value={userData.phone_number} id="phone_number" onChange={handleUserDataChange} />
                            </Grid>
                        </Grid>


                        <Grid container sx={{ mt: 5 }}>
                            <Grid item sm={12}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Биография</Typography>
                                {/* <DashboardTextField fullWidth multiline rows={4} maxRows={15} /> */}
                                <RTE onChange={handleUserDataChange} idName="description" defaultValue={userData.description} />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 5 }}>
                            <Grid item sm={12}>
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>Образование и опит</Typography>
                                <Typography sx={{ mb: 1, color: globals.colors.gray, fontWeight: 'bold', fontSize: 12 }}>(Моля, напишете ги едно под друго)</Typography>
                                <RTE onChange={handleUserDataChange} idName="education" defaultValue={userData.education} />
                                {/* <Typography sx={{ mb: 1, color: globals.colors.gray, fontSize: 12 }}>Избройте ги едно под друго</Typography> */}
                                {/* <DashboardTextField fullWidth multiline rows={4} maxRows={15} /> */}
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item>

                                <Button variant='contained' onClick={handleSaveChanges} type='submit' size='large' sx={{
                                    mt: 3, px: 5, backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                        backgroundColor: globals.colors.darkRed,
                                    },
                                }}> Запази промените</Button>
                            </Grid>
                        </Grid>
                    </TabPanel>

                    <TabPanel value={tabValue} index={7}>
                        <Grid container spacing={2}>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 17 }}>Правила за работа на учители,
                                    използващи платформата за обучение на eAcademiaBg:
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>1. Отговаряйте своевременно на комуникация от екипа ни</strong> - имейли, съобщения и обаждания е необходимо да се проверяват ежедневно и да отговаряте до 24 часа от получаването им, за да се гарантира качествена работа в платормата.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>2. Поддържайте връзка с учениците само през eAcademiaBg.com </strong>- не използвайте външни канали за комуникация, за да осигурим сигурност и проследяемост на общуването.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>3. Минималната цена на урок е €20 </strong>- това е стандарт за платформата и гарантира еднакви условия за всички преподаватели.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>4. Промени в цените или условията се правят само след одобрение от екипа</strong> - винаги се свързвайте с екипа ни, ако желаете да актуализирате цените или начина на работа.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>5. Ако по Ваша вина не се проведе урок осигурете безплатен урок на ученика </strong>- това поддържа доверието и коректността в обучителния процес.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>6. Стартирайте срещите за уроците 15 минути по-рано</strong> - така се избягват технически проблеми и закъснения, които могат да повлияят на урока.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>7. Спазвайте правилата за отмяна на уроци </strong>- уведомявайте навреме при нужда от промяна, както следва - 24 часа преди срещата, най-късно до 3 часа преди урока при извънредна ситуация.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>8. Не публикувайте или разпространявайте обидно, неподходящо или незаконно съдържание </strong>- поддържайте професионален и уважителен тон във всички материали и комуникация.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>9. Използвайте платформата само за разрешени и законни цели</strong> - забранено е разпространението на вируси, хакерски дейности или други вредни действия.
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}>
                                    <strong>10. Спазвайте авторските права </strong>- качвайте само съдържание, за което имате права, и уважавайте интелектуалната собственост на другите хора.
                                </Typography>
                            </Grid>

                        </Grid>
                    </TabPanel>

                    {/* Summer school registrations (leader only) */}
                    {user.id === SUMMER_SCHOOL_INSTRUCTOR_ID && (
                        <TabPanel value={tabValue} index={8}>
                            <SummerSchoolRegistrations />
                        </TabPanel>
                    )}

                    {/* Exam grading (only when the instructor has exams) */}
                    {hasExams && (
                        <TabPanel value={tabValue} index={examTabIndex}>
                            <ExamGrading exams={instructorExams} />
                        </TabPanel>
                    )}
                </Grid>

                {/* Notifications Section */}
                <Grid
                    item
                    xs={12}
                    sm={3}
                    justifyContent={"center"}
                    textAlign={"center"}
                    alignItems={"center"}
                >
                    <Paper elevation={2} >
                        <Typography>
                            <NotificationsNoneIcon sx={{ mr: 0.5, mb: -0.5 }} />
                            Известия
                        </Typography>
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            {notifications.map(notification => (
                                <Grid item>
                                    <a href={notification.url_path} style={{ textDecoration: 'none' }}>
                                        <Paper sx={{ p: 2, backgroundColor: globals.colors.backgroundColor }} elevation={4}>
                                            <Typography sx={{
                                                color: globals.colors.textColor, fontWeight: 'bold'
                                            }}>{notification.content}</Typography>
                                            <Typography sx={{ mt: 1, fontSize: 13, color: globals.colors.textColor }}>{notification.time} {notification.date} </Typography>
                                        </Paper>
                                    </a>
                                </Grid>
                            ))} 
                        </Grid>
                    </Paper>
                </Grid>
            </Grid >
        </Container >
    );
}

export default TeacherDashboard;